module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Deep River Soaps Website","short_name":"Deep River Soaps","description":"Highest quality soaps, made by hand at home","start_url":"/","background_color":"#DCDCDC","theme_color":"#DCDCDC","display":"minimal-ui","icon":"src/images/logo-favicon.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0dfe43502e4dd41b55672e63bfd0ffd3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
